import { render, staticRenderFns } from "./AndroidWalletButton.vue?vue&type=template&id=8bab78a6&scoped=true&"
var script = {}
import style0 from "./AndroidWalletButton.vue?vue&type=style&index=0&id=8bab78a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bab78a6",
  null
  
)

export default component.exports